export default function IconFlower({
  className,
}: {
  className?: string;
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      className={className}
    >
      <path
        d="M12.1133 2.97656C13.7684 3.82269 15.1866 5.06696 16.2412 6.58301L16.6045 7.10547L17.1787 6.83203C18.0483 6.41901 18.98 6.11467 19.9551 5.93555L20.25 5.88086V13C20.2499 17.5562 16.5563 21.25 12 21.25C7.44366 21.25 3.75 17.5563 3.75 13V5.88086L4.04492 5.93555C5.01984 6.11463 5.95091 6.41916 6.82031 6.83203L7.39551 7.10449L7.75781 6.58301C8.8124 5.06696 10.2306 3.82271 11.8857 2.97656L11.999 2.91797L12.1133 2.97656Z"
        stroke="currentColor"
        strokeWidth="1.5"
      />
    </svg>
  );
}
